import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=78821074"
import script from "./PriceSummary.vue?vue&type=script&lang=ts"
export * from "./PriceSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports